import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import Tabs from 'components/Tabs/Tabs'
import { elementTabs, refElements } from 'components/Canvas/renderer/utils/elementUtils'
import { updateObject } from 'helpers/objectHelpers'
import StylesSwitcher from './StylesSwitcher'
import EffectSwitcher from './EffectSwitcher'
import SettingSwitcher from './SettingSwitcher'
import ContentSwitcher from './ContentSwitcher'
import BackgroundSwitcher from './BackgroundSwitcher'
import ColumnsPanel from './ColumnsPanel'

const ElementFormController = ({
  element,
  element: {
    refElement,
    columns = [],
    background = {},
    defaultStyles = {},
    deviceStyles = {},
    defaultSettings = {},
    deviceSettings = {},
    defaultContent = {},
    deviceContent = {},
    elements = {},
  },
  updateElement,
}) => {
  const tabs = elementTabs[refElement]
  const handleUpdate = (val) => {
    // console.log('val handleUpdate', val)
    // console.log('val handleUpdate', updateObject(element, val))
    if (refElement === refElements.COLUMNS) {
      const newColumns = updateObject(element, { ['elements']: elements.map((item) => item.id) })
      return updateElement(updateObject(newColumns, _.omit(val, ['elements'])))
    }
    return updateElement(updateObject(element, val))
  }
  return (
    <div>
      <Tabs.C>
        {tabs.map((tab) => {
          switch (tab.tabValue) {
            case 'content':
              return (
                <ContentSwitcher
                  {...tab}
                  key={tab.tabValue}
                  elementId={element.id}
                  refElement={refElement}
                  value={{ defaultContent, deviceContent, defaultSettings, deviceSettings }}
                  onChange={handleUpdate}
                />
              )
            case 'styles':
              return (
                <StylesSwitcher
                  {...tab}
                  key={tab.tabValue}
                  refElement={refElement}
                  value={{
                    defaultStyles,
                    deviceStyles,
                    defaultSettings,
                    deviceSettings,
                    defaultContent,
                    deviceContent,
                  }}
                  onChange={handleUpdate}
                />
              )
            case 'settings':
              return (
                <SettingSwitcher
                  {...tab}
                  key={tab.tabValue}
                  refElement={refElement}
                  value={{ defaultSettings, deviceSettings, columns, elements }}
                  onChange={handleUpdate}
                  updateElement={updateElement}
                  element={element}
                />
              )
            case 'columns':
              return (
                <ColumnsPanel
                  {...tab}
                  key={tab.tabValue}
                  value={columns}
                  onChange={(val) => handleUpdate({ columns: val })}
                />
              )
            case 'background':
              return (
                <BackgroundSwitcher
                  {...tab}
                  key={tab.tabValue}
                  value={background}
                  onChange={(val) => handleUpdate({ background: val })}
                />
              )
            case 'effect':
              return (
                <EffectSwitcher
                  {...tab}
                  key={tab.tabValue}
                  refElement={refElement}
                  value={{
                    defaultSettings,
                    deviceSettings,
                    defaultStyles,
                    deviceStyles,
                  }}
                  onChange={handleUpdate}
                />
              )
            default:
              return null
          }
        })}
      </Tabs.C>
    </div>
  )
}

ElementFormController.propTypes = {}
ElementFormController.defaultProps = {}

export default ElementFormController



// WEBPACK FOOTER //
// ./src/components/Canvas/builder/components/panel/ElementFormController.js